import { ISelectInputProps, SelectInput } from '@framework/form';
import { useTranslation } from '@framework/i18n';
import React from 'react';

interface Props extends ISelectInputProps {
  formats?: string[];
}

const DefaultFormats = ['docx', 'doc', 'pdf', 'odt'] as const;

export function FileExtensionSelectInput(props: Props) {
  const { placeholder, ...otherProps } = props;
  const { t } = useTranslation();

  return (
    <SelectInput
      {...otherProps}
      allowClear
      showSearch
      placeholder={
        placeholder ??
        t(
          'inputs.file-extension-select-input.placeholder',
          'Scrivi e premi invio per aggiungere un nuovo formato',
        )
      }
      mode="tags"
      options={DefaultFormats.map(format => ({
        value: format,
        label: format,
      }))}
      onChange={(value, option, onChange) => {
        onChange(value?.length > 0 ? value?.join(',') : null);
      }}
      transformValue={value => value?.split(',') ?? []}
    />
  );
}
